const TrainingVideo = {
  url: 'https://wi.st/2B2jLmH',
  target: 'ezDriverTrainingVideo',
};

export default TrainingVideo;
